import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_URL.startsWith('http') ? `${API_URL}/api` : API_URL, // Use full URL or relative path
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Enable sending cookies with requests
  maxBodyLength: Infinity,
  maxContentLength: Infinity,
  // Force axios not to transform FormData - but ensure objects are JSON stringified
  transformRequest: (data) => {
    if (data instanceof FormData) {
      // Return the FormData as-is, let browser handle it
      return data;
    }
    // Ensure objects are JSON stringified
    if (typeof data === 'object' && data !== null) {
      return JSON.stringify(data);
    }
    return data;
  },
});

// Request interceptor - keep localStorage fallback for backwards compatibility
// but primarily rely on cookies now
api.interceptors.request.use(
  (config) => {
    // Try to get token from cookie first (via withCredentials)
    // Fallback to localStorage for backwards compatibility
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Don't override Content-Type for FormData - let axios set it automatically
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }

    // Log actual serialized data
    let serializedData;
    if (config.data instanceof FormData) {
      serializedData = 'FormData';
    } else if (typeof config.data === 'object') {
      serializedData = JSON.stringify(config.data);
    } else {
      serializedData = config.data;
    }

    console.log('[API Request]', config.method?.toUpperCase(), config.url, {
      hasData: !!config.data,
      dataType: config.data?.constructor?.name,
      contentType: config.headers['Content-Type'],
      data: serializedData,
      dataLength: serializedData?.length
    });

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => {
    console.log('[API Response OK]', response.status, response.config.url);
    return response.data;
  },
  (error) => {
    console.log('[API Response Error]', error.response?.status, error.message, error.config?.url, error.response?.data);
    if (error.response?.status === 401) {
      // Unauthorized - clear localStorage fallback and redirect to login
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error.response?.data || error.message);
  }
);

export default api;
